export default __webpack_public_path__ + "static/media/ki.fe6a4b1d.jpg";